/* eslint-disable import/no-unresolved */
import React, { useEffect, useState } from 'react'
import { Breadcrumb, BreadcrumbItem, BreadcrumbLink, Link } from '@chakra-ui/react'
import { ChevronRightIcon } from '@chakra-ui/icons'
import { useLocation, Location } from 'react-router-dom'

const IBbreadcrumb = () => {
  const location: Location = useLocation()
  const [breadcrumbFragment, setBreadcrumbFragment] = useState<string>('')
  const [spaceBottom, setSpaceBottom] = useState<boolean>(false)
  const [showBreadcrumb, setShowBreadcrumb] = useState<boolean>(true)
  useEffect(() => {
    switch (location.pathname.split('/')[1]) {
      case 'dashboard':
      case 'error':
        setBreadcrumbFragment('')
        setShowBreadcrumb(false)
        break
      case 'empresa':
        setBreadcrumbFragment('Sobre tu compañía')
        setShowBreadcrumb(true)
        break
      case 'cuentas':
      case 'servicios-gratuitos':
      case 'servicios-adicionales':
      case 'resumen':
        setBreadcrumbFragment('Tu plan y cuentas')
        setShowBreadcrumb(true)
        setSpaceBottom(true)
        break
      case 'planes':
        setBreadcrumbFragment('Tu plan y cuentas')
        setShowBreadcrumb(true)
        setSpaceBottom(false)
        break
      case 'colaboradores':
        setBreadcrumbFragment('Colaboradores')
        setShowBreadcrumb(true)
        setSpaceBottom(true)
        break
      default:
        setBreadcrumbFragment('')
        break
    }
  }, [location])

  return (
    showBreadcrumb && (
      <Breadcrumb
        spacing='10px'
        position='relative'
        zIndex={10}
        className={spaceBottom ? 'pbottom' : ''}
        pb='30px'
        textStyle='labelMd'
        separator={<ChevronRightIcon w='24px' h='24px' color='tertiary.500' />}
      >
        <BreadcrumbItem>
          {/* @ts-ignore */}
          <BreadcrumbLink as={Link} to='/dashboard' color='tertiary.500'>
            Inicio
          </BreadcrumbLink>
        </BreadcrumbItem>
        {breadcrumbFragment && (
          <BreadcrumbItem isCurrentPage>
            <BreadcrumbLink data-testid='breadcrumbFragment'>{breadcrumbFragment}</BreadcrumbLink>
          </BreadcrumbItem>
        )}
      </Breadcrumb>
    )
  )
}
export default IBbreadcrumb
